import React from 'react';

const MasterDashboard = () => {
    return (
        <>
            <div className="row">
                <div className="col-12">
                    <h1>Dashboard</h1>
                    <div className="separator mb-5"></div>
                </div>
            </div>
        </>
    )
}

export default MasterDashboard;